import { ValidatorFn, Validators } from '@angular/forms';
import XRegExp from 'xregexp/src/index.js';

export function NoSpecialCharactersValidator(): ValidatorFn {
  // All letters including ü,ł,ą etc without special characters like *,$,# etc.
  return Validators.pattern(XRegExp('^[0-9 \\pL]+$'));
}
